import { useContext, useCallback } from "react";
import { DownloadProgressContext, type DownloadProgressTuple } from "../contexts/downloadProgress";

export const useDownloadProgress = (id: string) => {
  const { remaining, setRemaining } = useContext(DownloadProgressContext);

  const remainingForThisDownload = remaining[id] ?? [0, 0];

  const setRemainingForThisDownload = useCallback(
    (
      next:
        | DownloadProgressTuple
        | ((prev: DownloadProgressTuple) => DownloadProgressTuple)
    ) => {
      let fn = next;
      if (!(typeof next === "function")) {
        fn = () => next;
      }

      setRemaining((allDownloads) => {
        const previous = allDownloads[id] ?? [0, 0];
        return {
          ...allDownloads,
          [id]: (fn as (prev: DownloadProgressTuple) => DownloadProgressTuple)(
            previous
          ),
        };
      });
    },
    [id, setRemaining]
  );

  return {
    remaining: remainingForThisDownload,
    setRemaining: setRemainingForThisDownload,
  };
};
